import React from 'react';
import './additionalInfo.less';

const LexileAdditionalInfo = () => (
	<div className="additional-info">
		<div className="flex-container">
			<div className="flex-item">
				<div className="info-text">
					<h2>Find books by Lexile</h2>
					<p>Looking for information on finding books at the right reading level? Lexile measures can help; they are measures of the text difficulty and reader ability. Students typically receive a Lexile reader measure from their school or teacher. To choose books at the right reading level using Lexiles, look for materials between 100L below and 50L above a child's Lexile measure.</p>
					<p>Don't know the Lexile reader measure for you or your reader? The Lexile text measure of a recently read book is a good	place to start.</p>

					<h2>More about Lexile measures</h2>
					<p>Lexiles are a measure of reading level developed by Metametrics. Books are given a <strong>Lexile text measure</strong> that indicates the reading demand of the text in terms of semantic difficulty (word frequency) and syntactic complexity (sentence length). Readers are given a <strong>Lexile reader measure</strong> that indicates their reading comprehension abilities. Matching reader and text measures makes it easy for parents and teachers to find engaging books, especially when combined with a child's age and interests.
						</p>
					<p>Lexiles can also be used to help adult readers of all levels. Since Lexiles are a measure of a readability (number of different words and sentence length) not age appropriateness, adult readers interested in improving their reading can find adult books below their Lexile level to start building their skills.
						</p>
					<p>You can learn more about the science behind Lexile scores and how they match to reading levels at <a href="http://www.lexile.com" target="_blank" rel="noopener noreferrer">http://www.lexile.com</a>.</p>
				</div>
			</div>

			<div className="flex-item">
				<aside className="info-chart">
					<table>
						<tr>
							<th>Lexile Measure </th>
							<th>Typical Grade Level</th>
						</tr>
						<tr>
							<td>up to 300L </td>
							<td>1 </td>
						</tr>
						<tr>
							<td>140L to 500L</td>
							<td>2 </td>
						</tr>
						<tr>
							<td>330L to 700L</td>
							<td>3 </td>
						</tr>
						<tr>
							<td>445L to 810L</td>
							<td>4 </td>
						</tr>
						<tr>
							<td>565L to 910L</td>
							<td>5 </td>
						</tr>
						<tr>
							<td>665L to 1000L</td>
							<td>6 </td>
						</tr>
						<tr>
							<td>735L to 1065L</td>
							<td>7 </td>
						</tr>
						<tr>
							<td>805L to 1100L</td>
							<td>8 </td>
						</tr>
						<tr>
							<td>855L to 1165L</td>
							<td>9 </td>
						</tr>
						<tr>
							<td>905L to 1195L</td>
							<td>10</td>
						</tr>
						<tr>
							<td>940L to 1210L</td>
							<td>11-12 </td>
						</tr>
					</table>
				</aside>
			</div>
		</div>
	</div>
)
export default LexileAdditionalInfo;



// WEBPACK FOOTER //
// ./src/react/views/readingLevel/LexileAdditionalInfo.jsx